import type { IndexSectionViewVariant } from '../index-section-utils';
import { GridIndexSectionView } from './grid';
import { ListIndexSectionView } from './list';
import type { IndexSectionViewProps } from './shared';
import { SplitIndexSectionView } from './split';

export function IndexSectionView({
  variant,
  ...props
}: IndexSectionViewProps & { variant: IndexSectionViewVariant }) {
  if (variant === 'grid') return <GridIndexSectionView {...props} />;
  if (variant === 'split') return <SplitIndexSectionView {...props} />;
  if (variant === 'list') return <ListIndexSectionView {...props} />;

  throw new Error(`Unsupported index section variant: ${variant}`);
}
